//--------------------------------------------------
// imported classes
//--------------------------------------------------
const Match = require('@/tbs/model/to/Match')
const ClassFunc = require('@/tbs/util/ClassFunc')

/**
 * The Player class works as the player translator.
 */
const tbs_model_to_Game = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, Match, arguments);
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_to_Game.prototype = {
    'game-start-date-time-required': '请选择开赛时间',
    'game-home-team-required': '请选择主队',
    'game-away-team-required': '请选择客队',
    'game-home-team-suit-required': '请选择主队队服',
    'game-away-team-suit-required': '请选择客队队服',
    'game-round-seq-label': '所属轮次',
    'game-round-group-label': '所属小组',
    'game-start-date-label': '开赛时间',
    'select-game-time': '选择时间',
    'game-home-team-label': '主队',
    'game-away-team-label': '客队',
    'game-home-team-suit-label': '主队队服',
    'game-away-team-suit-label': '客队队服',
    'select-team-suit': '选择队服',
    'game-referee-empty-field': '裁判组 未填写',
    'referee': '裁判',
    'live-broadcast': '直播',
    'score': '比分',
    'stats': '数据',
    'complete-game': '完赛',
    'delete-game': '删除比赛',
    'delete-game-confirm-message': '确认删除该比赛，无法进行还原',
    'game-versus': ' VS ',
    'regular-game': '（常规比赛）',
    'penalty-score': '点球',
    'change-home-team': '修改主队',
    'change-home-team-confirm-message': '该项操作会重置比赛详情中其他关联的部分，是否确认进行修改？',
    'change-away-team': '修改客队',
    'change-away-team-confirm-message': '该项操作会重置比赛详情中其他关联的部分，是否确认进行修改？',
    'change-round-group': '修改小组',
    'change-round-group-confirm-message': '该项操作会重置主客队相关以及比赛详情中其他关联的部分，是否确认进行修改？',
    'goal-count-label': '进球数',
    'assist-count-label': '助攻数',
    'yellowcard-count-label': '黄牌数',
    'redcard-count-label': '红牌数',
    'owngoal-count-label': '乌龙数',
    'penaltygoal-count-label': '点球数',
    'team-player-empty-hint': '暂无球员',
    'first-half': '上',
    'second-half': '下',
    'goal': '进球',
    'normal': '普通',
    'penalty-goal': '点球',
    'own-goal': '乌龙球',
    'assist': '助攻',
    'red-yellow-card': '红黄牌',
    'yellow-card': '黄牌',
    'red-card': '红牌',
    'substitution': '换人',
    'event-time': '时间（分）',
    'event-type': '事件',
    'event-goal-player': '进球队员',
    'event-assist-player': '助攻队员',
    'event-card-player': '领牌队员',
    'event-sub-out-player': '下场队员',
    'event-sub-in-player': '上场队员',
    'game-event-empty-hint': '暂无事件，请新建主客队事件',
    'choose-team-suit': '选择队服',
    'add-data': '添加数据',
    'game-player-id-required': '请选择参赛球员',
    'delete-stats': '删除统计',
    'delete-stats-confirm-message': '确认删除该球员统计，无法进行还原',
    'add-new-player': '添加新球员',
    'game-time-placeholder': '全场分钟',
    'event-time-required': '请选择事件时间',
    'event-team-required': '请选择事件球队',
    'event-type-required': '请选择事件',
    'event-spec-type-required': '请选择事件类型',
    'event-player-required': '请选择球员',
    'event-player-label': '[$num] $name',
    'stats-empty-hint': '暂无数据统计，请先添加数据',
    'delete-event': '删除事件',
    'delete-event-confirm-message': '确认删除该事件，无法进行还原',
    'recent-record': '最新记录',
    'recorder': '记录员',
    'historical-record': '历史记录',
    'game-score': '常规比分 $homeScore:$awayScore',
    'game-penalty-score': '点球 $homePenaltyScore:$awayPenaltyScore',
    'game-penalty-status': '点$homePenaltyScore:$awayPenaltyScore',
}

//--------------------------------------------------
// extends the Match
//--------------------------------------------------
ClassFunc.extend(tbs_model_to_Game, Match);

module.exports = tbs_model_to_Game